import { combineReducers } from 'redux';

import { templateCreationReducer } from './projectTemplatesCreate/store/templateCreation.reducer';

export const projectTemplates = combineReducers({
    templateCreation: templateCreationReducer,
});
